import { create } from 'zustand';
import { getSocket } from '../lib/socket';

export interface InviteToast {
  /** Stable id for AnimatePresence / dedupe. Format: `${gameId}:${ts}`. */
  id: string;
  gameId: string;
  code: string;
  from: { id: string; name: string; avatar: string | null };
  ts: number;
}

interface InvitesState {
  invites: InviteToast[];
  attach: () => () => void;
  dismiss: (id: string) => void;
  clear: () => void;
}

export const useInvites = create<InvitesState>((set, get) => ({
  invites: [],
  dismiss: (id) => set({ invites: get().invites.filter((i) => i.id !== id) }),
  clear: () => set({ invites: [] }),
  attach: () => {
    const sock = getSocket();
    const onInvite = (p: { gameId: string; code: string; from: { id: string; name: string; avatar: string | null } }) => {
      const ts = Date.now();
      // Coalesce: replace any existing toast for this game so a re-invite
      // refreshes the chip instead of stacking another row.
      const filtered = get().invites.filter((i) => i.gameId !== p.gameId);
      set({ invites: [...filtered, { id: `${p.gameId}:${ts}`, gameId: p.gameId, code: p.code, from: p.from, ts }] });
    };
    sock.on('invite:received', onInvite);
    return () => { sock.off('invite:received', onInvite); };
  },
}));
